import React from 'react';

import {Imports} from './Imports';
import {Suggestions} from './Suggestions';
import {WelcomeStructure} from './WelcomeStructure';

import type {WithRouterProps} from 'react-router';

export const ImportDashboard = (props: WithRouterProps) => (
  <WelcomeStructure {...props} currentStep={0} renderRegularLink={true}>
    {({onNext}) => <SweetSuperchargeDocuments onNext={onNext} {...props} />}
  </WelcomeStructure>
);

type Props = {
  onNext: (location: string) => unknown;
} & WithRouterProps;

const SweetSuperchargeDocuments = ({onNext, ...others}: Props) => (
  <>
    <Suggestions onNext={onNext} {...others} />
    <Imports onNext={onNext} />
  </>
);
